module.exports = __webpack_public_path__ + "img/img_1.9aefae5a.png";